__webpack_require__.p = "//givsum.s3.amazonaws.com/packs/";